

define(['angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-ui-components/src/dropdown/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-models/src/app/index'], function (angular, squid, template) {

    return angular.module('xo-select-shipping-country.directive', ['squid', 'xomodel.app', 'xomodel.checkout', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoSelectShippingCountry', function () {

        return {
            template: template,

            scope: {
                token: '=',
                shippingAddress: '=',
                disableChangeShippingCountry: '='
            },

            controller: function controller($rootScope, $scope, $populate, $locale, $LocaleConfigModel, $CheckoutAppDataModel) {

                var defaultCountry = $scope.shippingAddress && $scope.shippingAddress.country || $locale.country;

                var countries = $locale.content.get('countryList', {});
                var countryList = [];

                function insertDefaultCountryTop() {
                    countryList.unshift({
                        key: defaultCountry,
                        value: countries[defaultCountry]
                    });
                }

                insertDefaultCountryTop();

                $scope.countryList = countryList;

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                }).then(function () {
                    return $populate($scope, {
                        localeConfigModel: $LocaleConfigModel.instance($scope.checkoutAppData.merchant.merchant_country)
                    }).then(function () {

                        var shippingCountries = $scope.localeConfigModel && $scope.localeConfigModel.xBorderCountries;

                        function getSortedCountryList() {
                            countries = $locale.content.get('countryList', {});
                            countryList = [];

                            angular.forEach(shippingCountries, function (shippingCountry) {
                                if (shippingCountry && angular.isString(shippingCountry)) {
                                    var countryCode = shippingCountry.split(',')[0];
                                    if (countryCode && countryCode !== defaultCountry && countries[countryCode]) {
                                        countryList.push({
                                            key: countryCode,
                                            value: countries[countryCode]
                                        });
                                    }
                                }
                            });

                            countryList.sort(function (a, b) {
                                return a.value.localeCompare(b.value);
                            });

                            insertDefaultCountryTop();
                            $scope.countryList = countryList;
                        }

                        $scope.$on('contentChange', getSortedCountryList);

                        getSortedCountryList();
                    });
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-form-components/src/select-shipping-country/directive.js
 ** module id = 303
 ** module chunks = 1
 **/